import { formatDisplayDateTime } from './formatDisplayDateTime';

/**
 * Kinds from advisor ActivityInputBar (POST .../history/note). Keep aligned with backend ADVISOR_TIMELINE_KINDS.
 */
export const ADVISOR_TIMELINE_KINDS = new Set([
  'internal_note',
  'call_inbound',
  'call_outbound',
  'whatsapp_inbound',
  'whatsapp_outbound',
  'email_inbound',
  'email_outbound',
]);

export function isAdvisorTimelineEntry(e) {
  if (!e) return false;
  if (e.category === 'note') return true;
  const k = e.kind;
  return typeof k === 'string' && ADVISOR_TIMELINE_KINDS.has(k);
}

/**
 * Map Mongo case-history API row to ActivityInputBar / HistoryLog shape.
 */
export function mapCaseHistoryToLogEvent(e) {
  if (!e) return null;
  const advisor = isAdvisorTimelineEntry(e);
  return {
    id: e.id,
    at: e.at,
    type: advisor ? 'note' : 'activity',
    subtype: e.kind,
    text: e.body,
    documentTag: e.meta?.document_tag,
    title: e.title,
    actor_name: e.actor_name,
  };
}

/** Match backend list_case_history filter semantics (client-side on cached events). */
export function matchesHistoryFilter(e, filter) {
  if (!e || filter === 'all') return true;
  if (filter === 'notes') return isAdvisorTimelineEntry(e);
  if (filter === 'activity') return e.category === 'system';
  return true;
}

/** Merge timeline rows from profile + multiple cases; newest first. De-duplicates by event id. */
export function mergeCaseHistoryEvents(rows) {
  const seen = new Set();
  const out = [];
  for (const e of rows) {
    const id = e?.id;
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(e);
  }
  out.sort((a, b) => {
    const ta = a.at ? new Date(a.at).getTime() : 0;
    const tb = b.at ? new Date(b.at).getTime() : 0;
    return tb - ta;
  });
  return out;
}

/** @param {string} [i18nLanguage] Pass `i18n.language` for localized month/time. */
export function formatCaseHistoryAt(iso, i18nLanguage = 'en') {
  return formatDisplayDateTime(iso, i18nLanguage);
}
